export default __webpack_public_path__ + "static/media/West_Water_final.1deb8a3c.mp3";